import { Helmet } from 'react-helmet-async'
import siteData from '../data/site.json'
import Hero from '../components/home/Hero'
import FeaturedWorks from '../components/home/FeaturedWorks'

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>{siteData.seo.defaultTitle}</title>
        <meta name="description" content={siteData.seo.defaultDescription} />
        <meta property="og:title" content={siteData.seo.defaultTitle} />
        <meta property="og:description" content={siteData.seo.defaultDescription} />
        <meta property="og:type" content="website" />
      </Helmet>

      <div>
        <Hero />
        <FeaturedWorks />
      </div>
    </>
  )
}
